import { defineMessages } from 'react-intl';

export default defineMessages({
  settingsNotImplemented: {
    id: 'settings.notImplemented',
    defaultMessage: 'Settings Not Implemented Yet'
  },
});